export default function isCardExpired(dateStr: string): boolean {
  if (!dateStr) return false;
  const [month, year] = dateStr.split("/");
  const nextMonth = new Date(parseInt(`20${year}`, 10), parseInt(month, 10), 1);
  nextMonth.setDate(nextMonth.getDate() - 1);
  const now = new Date();
  return now > nextMonth;
}
